/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * What an uploaded image is for.
 */
export enum ImageKind {
  ORG_LOGO = "ORG_LOGO",
  TUTOR_PHOTO = "TUTOR_PHOTO",
  EMAIL_LOGO = "EMAIL_LOGO",
  EMAIL_IMAGE = "EMAIL_IMAGE",
}
